import { FETCH_BUNDLE } from './fetchBundle'
import { client } from '../../components/ApolloProvider'
import { FetchResult } from '@apollo/client'
import { BundleModel } from './models/bundle.model'
import { TableSortColumn } from '../../components/Table'
import { SortDirection } from '../../types/various'
import { FETCH_BUNDLES } from './fetchBundles'
import { BUNDLE_DATE_FORMAT, BUNDLE_ITEMS_PER_PAGE } from '../../constant'
import { BundleFiltersModel } from './models/bundle-filters.model'
import { FETCH_BUNDLE_HISTORY } from './fetchBundleHistory'
import { BundleHistoryEdgeModel } from './models/bundle-history.model'
import { BundleExtendedModel } from './models/bundle-extended.model'
import DateUtils from '../../utils/date'
import { add } from 'date-fns'
import { FREE_BUNDLE } from './freeBundle'
import { FREE_BUNDLE_SCHEDULE } from './freeBundleSchedule'

const bundleApi = {
  fetchBundle: (bundleId: string): Promise<FetchResult<{ node: BundleExtendedModel }>> => {
    return client.query({
      query: FETCH_BUNDLE,
      variables: {
        id: bundleId,
      },
    })
  },

  fetchBundles: (
    filters: BundleFiltersModel,
    first: number,
    sortColumn?: TableSortColumn,
    sortDirection?: SortDirection
  ): Promise<FetchResult<{ bundles: { nodes: BundleModel[]; totalCount: number } }>> => {
    let transformedDate = null

    if (filters.month) {
      const date = add(new Date(filters.month), { hours: 2 })
      transformedDate = DateUtils.parseAndFormat(date, BUNDLE_DATE_FORMAT)
    }

    return client.query({
      query: FETCH_BUNDLES,
      variables: {
        first,
        last: BUNDLE_ITEMS_PER_PAGE,
        sortColumn: sortColumn ?? null,
        sortDirection: sortDirection ?? null,
        filters: {
          ...(filters.text && { text: filters.text }),
          ...(filters.month && { month: transformedDate }),
        },
      },
    })
  },

  fetchBundleHistory: (
    bundleId: string
  ): Promise<FetchResult<{ bundleHistory: { edges: BundleHistoryEdgeModel[] } }>> => {
    return client.query({
      query: FETCH_BUNDLE_HISTORY,
      variables: {
        bundleId,
      },
    })
  },

  freeBundle: (
    bundleId: string
  ): Promise<
    FetchResult<{
      freeBundle: {
        bundle: { id: BundleModel['id']; bundleSchedules: BundleModel['bundleSchedules'] }
      }
    }>
  > => {
    return client.mutate({
      mutation: FREE_BUNDLE,
      variables: {
        id: bundleId,
      },
    })
  },

  freeBundleSchedule: (
    bundleScheduleId: string
  ): Promise<
    FetchResult<{
      freeBundleSchedule: {
        bundleSchedule: BundleExtendedModel['bundleSchedules'][0]
      }
    }>
  > => {
    return client.mutate({
      mutation: FREE_BUNDLE_SCHEDULE,
      variables: {
        id: bundleScheduleId,
      },
    })
  },
}

export default bundleApi
